import React, {FC, PropsWithChildren} from 'react';
import styled, {css} from 'styled-components';

/*
 * Props.
 */

interface MessageViewerActionZoneProps {
  isInPopup: boolean;
}

/*
 * Style.
 */

interface ZoneStyleProps {
  $isInPopup: boolean;
}
const StyledZoneDiv = styled.div<ZoneStyleProps>`
  display: grid;
  grid-auto-flow: column;
  grid-auto-columns: min-content;
  grid-column-gap: 12px;
  margin: 16px 4px 16px 16px;
  ${(p) => maybePopupStyle(p)};
`;

function maybePopupStyle(props: ZoneStyleProps) {
  if (!props.$isInPopup) {
    return '';
  }

  return css`
    margin: 0;
    padding: 16px;
    border-top: 1px solid ${(p) => p.theme.greys.shade30};
  `;
}

/*
 * Component.
 */

export const MessageViewerActionZone: FC<PropsWithChildren<MessageViewerActionZoneProps>> = ({
  isInPopup,
  children,
}) => <StyledZoneDiv $isInPopup={isInPopup}>{children}</StyledZoneDiv>;
